import React, { forwardRef } from "react";

const CheckBox = forwardRef(
  (
    {
      labelKey,
      label,
      description,
      labelClassName = "",
      descriptionClassName = "",
      className,
      checked,
      defaultChecked,
      onChange,
      loading = false,
      disabled = false,
      ...rest
    },
    ref
  ) => {


    const is_controlled = typeof onChange === "function" && defaultChecked === undefined;

    const state_props = is_controlled
      ? { checked: !!checked, onChange }
      : checked !== undefined
        ? { checked: !!checked, readOnly: true }
        : { defaultChecked, onChange };

    return (
      <label className={`group flex items-start text-sm w-full peer ${loading ? "cursor-wait" : "cursor-pointer"} ${className || ""}`}>

        <input
          ref={ref}
          type="checkbox"
          className="hidden"
          disabled={disabled || loading}
          {...state_props}
          {...rest}
        />

        {loading ? (
          <span
            aria-hidden="true"
            className="w-5 h-5 shrink-0 rounded-full border-2 border-jmt-neutral-300 border-t-jmt-primary-800 animate-spin"
          />
        ) : (
          <div
            className={`w-5 h-5 shrink-0 rounded-md border-2 border-jmt-neutral-300 ${disabled ? " bg-jmt-neutral-100" : "bg-jmt-white"}
            flex items-center justify-center transition-colors duration-150
            group-has-checked:bg-jmt-primary-800 group-has-checked:border-jmt-primary-800`}
          >
            <svg
              className="w-4 h-4 text-jmt-white hidden group-has-checked:block"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="3.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M5 13l4 4L19 7" />
            </svg>
          </div>
        )}

        <div className="ms-2 gap-2 flex flex-col w-full">
          <span className={`
            text-xs lg:text-sm text-jmt-main font-normal truncate transition-all duration-200
            group-has-checked:font-bold
            ${labelClassName}
          `}>
            {labelKey ? labelKey : label}
          </span>

          {description && (
            <span className={`text-xs text-jmt-neutral-600 ${descriptionClassName}`}>
              {description}
            </span>
          )}
        </div>
      </label>
    );
  }
);

CheckBox.displayName = "CheckBox";

export default CheckBox;
